import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

// PrimeNg
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { LupasComponent } from '../../general/lupas/lupas.component';
import { BotoneraApiService } from '../botonera.api.service';
import { IRetornarDocumento } from '../botonera.interface';
import { IFormSearchLupa } from '../../general/lupas/interfaces/lupas.interfaces';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-modal-retornar-documento',
  standalone: true,
  imports: [ReactiveFormsModule, ButtonModule, LupasComponent],
  templateUrl: './modal-retornar-documento.component.html',
  styleUrls: ['./modal-retornar-documento.component.scss'],
})
export class ModalRetornarDocumentoComponent {
    ref = inject(DynamicDialogRef);
    config = inject(DynamicDialogConfig);
    apiService = inject(BotoneraApiService);
  
    form: FormGroup = new FormGroup({});
    request: IRetornarDocumento;
  
    // lupa
    dataSearchLupaPasoDestino: IFormSearchLupa = {
      idFormulario: 'noFormMotivosRetornDocument',
      campo: 'noFormMotivosRetornDocument',
      label: 'Retornar a paso',
      dependencias: { IdfdArchivo: null },
      required: true,
    };
  
    constructor() {
      this.request = this.config.data;
      this.buildForm();
      this.setDependenciasLupa();
    }
  
    async confirmar() {
      // recoge el motivo
      this.request.Motivo = this.form.get('Motivo')?.value;
      this.request.IdControlDevoluciones = this.form.get('IdControlDevoluciones')?.value;
  
      // envia la solicitud al API
      const response = await lastValueFrom(this.apiService.PostRetornarDocumento(this.request));
  
      // cierra el modal retornando la respuesta
      this.ref.close(response);
    }
  
    cerrarModal() {
      this.ref.close(false);
    }
  
    // Lupa
    buildForm() {
      this.form = new FormGroup({
        IdControlDevoluciones: new FormControl(null, Validators.required),
        Motivo: new FormControl(null, Validators.required),
      });
    }
  
    setDependenciasLupa() {
      this.dataSearchLupaPasoDestino.dependencias = {
        IdfdArchivo: this.request.IdfdArchivo
      };
    }
}
